import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

// Slide-in detail panel for a clicked row.
// Props:
//   open, onClose, title
//   sections: [{ title, items: [{ label, value }] }]
//   children (optional custom body, rendered after sections)
export default function DetailDrawer({ open, onClose, title, sections = [], children }) {
  if (!open) return null;
  return (
    <>
      <div className="drawer-overlay" onClick={onClose} />
      <aside className="drawer-panel" role="dialog" aria-modal="true">
        <div className="drawer-header">
          <h3>{title}</h3>
          <button className="drawer-close" onClick={onClose} aria-label="Close">
            <CloseIcon />
          </button>
        </div>
        <div className="drawer-body">
          {sections.map((section, i) => (
            <div className="detail-section" key={i}>
              {section.title ? <h4>{section.title}</h4> : null}
              <div className="detail-grid">
                {section.items.map((item, j) => (
                  <div className="detail-item" key={j}>
                    <span className="label">{item.label}</span>
                    <span className="value">{item.value ?? '—'}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
          {children}
        </div>
      </aside>
    </>
  );
}
